// extracted by mini-css-extract-plugin
export default {"downloadBorderStyle":"Zustimmung_downloadBorderStyle__Z1EQa"};